'use client';

import type { FC } from 'react';
import type { ImageProps } from 'next/image';
import NextImage from 'next/image';
import { akamaiLoader } from './loader';

// TODO: img sizes and akamai settings tbd and custom akamai image loader has to be build
export const getImageSize = (src: ImageProps['src']) => {
  const type = typeof src === 'string' && src?.split('?').pop();
  switch (type) {
    case '$PL_portrait_hq$':
      return { width: 339, height: 485 };
    case '$PL_landscape_hq$':
      return { width: 399, height: 236 };
    case '$PL_square_highlight$':
      return { width: 1000, height: 1000 };
    default:
      // TODO: check what if no case match
      // return { width: 339, height: 485 };
      return undefined;
  }
};

/**
 * Image component based on https://nextjs.org/docs/basic-features/image-optimization
 * */
export const Image: FC<ImageProps> = ({ src, width, height, ...props }) => (
  <NextImage
    src={src}
    width={props.fill ? undefined : width || getImageSize(src)?.width}
    height={props.fill ? undefined : height || getImageSize(src)?.height}
    loader={akamaiLoader}
    unoptimized={process.env.NODE_ENV === 'test'}
    {...props}
  />
);
